import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'go_to_event_details';
export const useGoToEventDetailsTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Детали события',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Event details',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Detalhes do evento',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Detalles del evento',
  },
}) as Record<string, unknown>;
